<template>
  <v-app>
    <v-toolbar app>
      <v-img
        v-if="isHomeCare"
        :src="require('@/assets/chc-logo.png')"
        height="90"
        width="300"
        :contain="true"
      ></v-img>
      <v-img
        v-if="isHospice"
        :src="require('@/assets/gsh-logo.png')"
        height="90"
        width="300"
        :contain="true"
      ></v-img>

      <v-toolbar-title class="headline text-uppercase">
        <span d-inline class="font-weight-light">Physician Referral Form</span>
      </v-toolbar-title>
    </v-toolbar>

    <v-content>
      <HomeCareReferralForm v-if="isHomeCare"/>
      <HospiceReferralForm v-if="isHospice"/>
    </v-content>
  </v-app>
</template>

<script>
import HomeCareReferralForm from "./components/HomeCareReferralForm";
import HospiceReferralForm from "./components/HospiceReferralForm";

export default {
  name: "App",
  components: {
    HomeCareReferralForm,
    HospiceReferralForm
  },
  data() {
    return {
      form: null
    };
  },
  beforeMount() {
    const params = window.location.search.substring(1).split("&");

    for (var i = 0; i < params.length; i++) {
      var pair = params[i].split("=");
      if (decodeURIComponent(pair[0]) === "form") {
        this.form = decodeURIComponent(pair[1]);
      }
    }
  },
  computed: {
    isHomeCare() {
      return this.form === "homecare";
    },
    isHospice() {
      return this.form === "hospice";
    }
  }
};
</script>

<style>
.v-toolbar,
.v-toolbar__content {
  height: 100px !important;
}

.v-toolbar__content .v-image__image {
  width: 300px !important;
}

.v-content {
  padding-top: 100px !important;
}
</style>